"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicCatalogService = void 0;
var tslib_1 = require("tslib");
var catalog_service_1 = require("./catalog-service");
var PublicCatalogService = /** @class */ (function (_super) {
    tslib_1.__extends(PublicCatalogService, _super);
    function PublicCatalogService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PublicCatalogService;
}(catalog_service_1.CatalogService));
exports.PublicCatalogService = PublicCatalogService;
//# sourceMappingURL=public-catalog-service.js.map